module.exports = __webpack_public_path__ + "static/media/on-the-go.eced4314.jpg";